<template>
  <b-navbar class="bg-lightblack banner">
    <b-navbar-brand href="#">
      <img src="@/assets/logo.png" width="40" height="40" />

      <div class="d-inline-block align-middle ml-3">
        <h3 class="text-gold d-inline">L'ANYVERS</h3>
      </div>
    </b-navbar-brand>
  </b-navbar>
</template>

<script>
import { BNavbar, BNavbarBrand } from "bootstrap-vue";

export default {
  name: "Banner",
  components: { BNavbar, BNavbarBrand },
};
</script>

<style scoped>
.banner {
  border-bottom: 1px solid #292037;
  height: 67px;
}
</style>
